import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import modalsMap from './modalsMap';
import { getCurrentModal, getCurrentModalProps } from '../redux/modals/selectors';
import { hideModal } from '../redux/modals/actions';

const ModalsRoot = ({ modalType, modalProps, hideModal: hideModalProp, theme }) => {
    if (!modalType || !modalsMap[modalType]) {
        return null;
    }

    const Modal = modalsMap[modalType];
    return <Modal { ...modalProps } onClose={ hideModalProp } theme={ theme } showModal />;
};

ModalsRoot.propTypes = {
    modalType: PropTypes.string,
    modalProps: PropTypes.shape({}),
    theme: PropTypes.shape({}),
    hideModal: PropTypes.func.isRequired,
};

ModalsRoot.defaultProps = {
    modalType: null,
    modalProps: {},
    theme: {},
};

const mapStateToProps = state => ({
    modalType: getCurrentModal(state),
    modalProps: getCurrentModalProps(state),
});

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalsRoot);
